import {
  Box,
  Stack,
  Typography,
  type SxProps,
  type Theme,
} from "@mui/material";
import { type OrganizationMessageDetailQuery } from "../../../generated/graphql";
import { ACTION_LABEL, formatDateTime } from "../message-content";

type History = OrganizationMessageDetailQuery["organizationMessageHistory"];

const styles = {
  title: { fontWeight: 600, mb: 1 },
  entry: { position: "relative", pl: 3, pb: 1.5 },
  dot: {
    position: "absolute",
    left: 4,
    top: 6,
    width: 8,
    height: 8,
    borderRadius: "50%",
    bgcolor: "primary.main",
  },
  line: {
    position: "absolute",
    left: 7,
    top: 16,
    bottom: 0,
    width: 2,
    bgcolor: "divider",
  },
} satisfies Record<string, SxProps<Theme>>;

/** What staff did to the message, oldest first, with who did it. */
const MessageHistory = ({ history }: { readonly history: History }) => (
  <Box>
    <Typography sx={styles.title}>History</Typography>
    <Stack>
      {history.map((event, index) => (
        <Box
          key={`${String(event.createdAt)}-${event.action}-${event.actorUserUuid}`}
          sx={styles.entry}
        >
          <Box sx={styles.dot} />
          {index < history.length - 1 && <Box sx={styles.line} />}
          <Typography variant="body2">
            <strong>{ACTION_LABEL[event.action]}</strong> by{" "}
            {event.actorName ?? "a former staff member"}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {formatDateTime(event.createdAt)}
          </Typography>
        </Box>
      ))}
    </Stack>
  </Box>
);

export default MessageHistory;
